// MerchTextArea.jsx;

import { Formik, Form, useField } from "formik";
import React from "react";

const MerchTextInputView = ({ label, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props);

  return (
    <>
      <label htmlFor={props.id || props.name}>{label}</label>
      <input className="bordered-light text-box" {...field} {...props} />
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : (
        ""
      )}
    </>
  );
};

export default MerchTextInputView;
